export default __webpack_public_path__ + "static/media/play-button.556f3df7.svg";